/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.package').controller('PMDatePropertiesSectionController', function ($scope, SearchFilterService) {
	var self = this;

	self.searchCriteria = SearchFilterService.searchCriteria;

	self.selectedDateProperty = SearchFilterService.searchCriteria.dateProperty || '';
	self.selectedDateProperties = {
		'originalReleaseDate': {
			fromDate: (SearchFilterService.searchCriteria.dateProperty === 'originalReleaseDate')? SearchFilterService.searchCriteria.fromDate : new Date(),
			toDate: (SearchFilterService.searchCriteria.dateProperty === 'originalReleaseDate')? SearchFilterService.searchCriteria.toDate : new Date()
		},
		'lastEdited': {
			fromDate: (SearchFilterService.searchCriteria.dateProperty === 'lastEdited')? SearchFilterService.searchCriteria.fromDate : new Date(),
			toDate: (SearchFilterService.searchCriteria.dateProperty === 'lastEdited')? SearchFilterService.searchCriteria.toDate : new Date()
		},
		'dateCreated': {
			fromDate: (SearchFilterService.searchCriteria.dateProperty === 'dateCreated')? SearchFilterService.searchCriteria.fromDate : new Date(),
			toDate: (SearchFilterService.searchCriteria.dateProperty === 'dateCreated')? SearchFilterService.searchCriteria.toDate : new Date()
		}
	};

	$scope.$on('modal.closing', function () {
		SearchFilterService.searchCriteria.dateProperty = self.selectedDateProperty || null;
		SearchFilterService.searchCriteria.fromDate = (self.selectedDateProperty)?  self.selectedDateProperties[self.selectedDateProperty].fromDate : null;
		SearchFilterService.searchCriteria.toDate = (self.selectedDateProperty)? self.selectedDateProperties[self.selectedDateProperty].toDate : null;
	});
});
